export default __webpack_public_path__ + "static/media/rec2.fcc57b0e.svg";